module.exports = __webpack_public_path__ + "img/kpjz_icon.1e4eb97d.png";